<template>
  <div class="gc-form-header-toolbar">
    <DxToolbar class="view-toolbar form-header-toolbar" ref="toolbar-header">
      <DxItem
        #default
        :location="formLocation"
        :locate-in-menu="formLocation"
        v-if="toolbarOptions.toolbarFormItems"
      >
        <gc-form
          :formOptions="toolbarFormOptions"
          :formItems="toolbarOptions.toolbarFormItems"
          :isNormal="true"
          :scrollingEnabled="false"
          :data-model="dataModel"
          :formMode="baseView.mode"
          :validationGroup="'gc-form-header-toolbar'"
          :ref="'toolbar-form'"
          :formContentReady="
            toolbarOptions.formContentReady
              ? toolbarOptions.formContentReady
              : undefined
          "
          :fromFrom="'gc-form-header-toolbar-form-1'"
          :valueChangeCallBack="toolbarFormCallBack"
          :checkValid="toolbarFormisValid"
          :id="'toolbar-form'"
        ></gc-form>
      </DxItem>

      <DxItem
        #default
        location="before"
        locate-in-menu="before"
        v-if="toolbarOptions.header"
      >
        <div>
          <span class="text-header ml-none">{{ toolbarOptions.title }}</span>
        </div>
      </DxItem>

      <DxItem
        #default
        location="after"
        locate-in-menu="after"
        v-if="toolbarOptions.toolbarAfterFormItems"
      >
        <gc-form
          :formOptions="toolbarFormOptions"
          :formItems="toolbarOptions.toolbarAfterFormItems"
          :isNormal="true"
          :data-model="dataModel"
          :formMode="baseView.mode"
          v-if="toolbarOptions.toolbarAfterFormItems"
          :ref="'toolbar-after-form'"
          :fromFrom="'gc-form-header-toolbar-form-2'"
          :id="'toolbar-after-form'"
        ></gc-form>
      </DxItem>

      <DxItem
        v-if="
          toolbarOptions.customStatus &&
          toolbarOptions.customStatus.enabled == true
        "
        #default
        location="after"
        locate-in-menu="auto"
      >
        <gc-status-chip
          :status="computedCustomStatus"
          v-if="computedCustomStatus"
        />
      </DxItem>

      <DxItem
        v-if="toolbarOptions.status == true"
        #default
        location="after"
        locate-in-menu="auto"
      >
        <gc-status-chip :status="computedStatus" />
      </DxItem>

      <DxItem
        v-if="
          toolbarOptions.email == true &&
          toolbarOptions.screenName &&
          emailRecords.length > 0
        "
        location="after"
        locate-in-menu="auto"
        #default
      >
        <gc-toolbar-email
          :data="emailRecords"
          :dataModel="dataModel"
          :showLoading="setLoading"
          :menuItems="toolbarOptions.emailMenuItems"
          :baseView="baseView"
        />
      </DxItem>

      <!-- <div v-for="(btn, i) in customButtons" v-bind:key="i"> -->
      <DxItem
        v-for="(btn, i) in customButtons"
        v-bind:key="i"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        :options="btn"
      />
      <!-- </div> -->

      <DxItem
        v-if="
          toolbarOptions.pdf == true &&
          toolbarOptions.screenName &&
          previewPdfs.length > 0
        "
        location="after"
        locate-in-menu="auto"
        #default
      >
        <gc-toolbar-print-preview
          :data="previewPdfs"
          :dataModel="dataModel"
          :showLoading="setLoading"
        />
      </DxItem>

      <DxItem
        v-if="
          toolbarOptions.audit == true && baseView && baseView.mode == 'review'
        "
        :options="toolbar.audit"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
      />
      <DxItem
        v-if="toolbarOptions.notes == true"
        :options="toolbar.notes"
        location="after"
        locate-in-menu="auto"
        widget="dxDropDownButton"
      />

      <DxItem
        v-if="toolbarOptions.copy == true"
        :options="toolbar.copy"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
      />

      <DxItem
        v-if="toolbarOptions.delete == true"
        :options="toolbar.delete"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
      />

      <DxItem
        v-if="
          toolbarOptions.save == true && baseView && baseView.mode != 'review'
        "
        :options="toolbarOptions.saveOptions ? saveOptions : toolbar.save"
        location="after"
        locate-in-menu="auto"
        :widget="toolbarOptions.saveOptions ? 'dxDropDownButton' : 'dxButton'"
      />

      <DxItem
        v-if="
          toolbarOptions.save == true && baseView && baseView.mode == 'review'
        "
        :options="toolbar.edit"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
      />

      <DxItem
        v-if="toolbarOptions.closeSplit == true"
        :options="toolbar.closeSplit"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
      />

      <DxItem
        :options="toolbar.ellipsis"
        location="after"
        locate-in-menu="auto"
        widget="dxDropDownButton"
        v-if="
          toolbarOptions.ellipsis && toolbarOptions.ellipsis.visible == true
        "
      />
    </DxToolbar>

    <gc-popup
      :popup-visible="commentsPopupVisible"
      :popup-title="
        toolbarOptions.commentsTitle ? toolbarOptions.commentsTitle : 'Comments'
      "
      :back-button-function="popUpBackButtonClick"
      v-if="commentPopUpItems"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
      :popup-height="585"
    >
      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="formOptions"
          :formItems="commentPopUpItems"
          :formHeight="450"
          :isNormal="true"
          :data-model="dataModel"
          :formMode="baseView ? baseView.mode : 'review'"
          :validationGroup="'comments-form-data'"
          :formTitle="'comments'"
          v-if="commentPopUpItems"
          :valueChangeCallBack="commentCalueChangeCallBack"
          :checkValid="isValid"
          :fromFrom="'gc-form-header-toolbar-form-3'"
          :id="'gc-form-header-toolbar-form-3'"
        ></gc-form>
      </div>
    </gc-popup>

    <gc-popup
      v-if="auditPopupVisible"
      :popup-visible="auditPopupVisible"
      popup-title="Audit History"
      :back-button-function="popUpBackButtonClick"
      :popup-height="200"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="auditFormOptions"
          :formItems="getAuditFormItems"
          :isNormal="true"
          :data-model="auditModel"
          v-if="getAuditFormItems"
          :fromFrom="'gc-form-header-toolbar-form-4'"
          :id="'gc-form-header-toolbar-form-4'"
        ></gc-form>
      </div>
    </gc-popup>

    <gc-popup
      :popup-visible="notesPopupVisible"
      :popup-title="'Order Notes'"
      :back-button-function="popUpBackButtonClick"
      :popup-width="'70%'"
      :popup-height="650"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 transaction-list">
        <GcDataGrid
          :grouping="false"
          :export="false"
          :summary="false"
          :paging="true"
          :dataSourceConfig="{
            localDataList: true,
            items: dataModel.Notes,
            serverPaging: true,
            allowGrouping: false,
          }"
          :columns="orderNotesColumns"
          :gridToolbar="orderNotesGridToolbar"
          :padColumn="false"
          :id="'gc-popup-search-for-item'"
          :auto-expand-all="false"
          :gridOptions="{ dxScrolling: 'standard' }"
          :isLocalDataSource="true"
          :ref="'gc-popup-order-notes'"
          :dxScrolling="'standard'"
          :isEditableGrid="false"
          :key="1"
          v-if="notesPopupVisible"
          :gridHeightOverWrite="540"
        />
      </div>
    </gc-popup>
  </div>
</template>

<script>
// import GcForm from "./gc-form.vue";
import gcPopup from "./gc-popup.vue";
// import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { mapGetters } from "vuex";

export default {
  components: { gcPopup },
  mixins: [FormMixin],
  props: {
    toolbarOptions: {
      type: Object,
      default: () => {},
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    backRoute: {
      type: String,
      default: undefined,
    },
    itemSaveCallBack: {
      type: Function,
      default: () => {},
    },
    formLocation: {
      type: String,
      default: "before",
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
    baseView: {
      type: Object,
      default: () => {},
    },
    customButtons: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      formOptions: {
        gcLabelLocation: "top",
      },
      auditFormOptions: {
        gcLabelLocation: "left",
      },
      toolbarFormOptions: {
        gcLabelLocation: "left",
      },

      commentsPopupVisible: false,
      notesPopupVisible: false,
      auditPopupVisible: false,
      toolbar: {
        notes: {
          icon: "file",
          items: this.toolbarOptions.notesItems
            ? this.toolbarOptions.notesItems
            : [
                this.toolbarOptions.commentsTitle
                  ? this.toolbarOptions.commentsTitle
                  : "Order Comments",
              ],
          dropDownOptions: this.toolbarOptions.notesDropDownOptions
            ? this.toolbarOptions.notesDropDownOptions
            : { width: 150 },
          class: "gc-dropdown-icon-button",
          stylingMode: "text",
          showArrowIcon: false,
          onClick: () => {
            // this.isContextMenuVisible = true;
          },
          onItemClick: (e) => {
            this.formKey = Math.random().toString(36).substring(7);
            // if (e.itemData == "Order Comments") {

            // } else
            if (e.itemData == "Order Notes") {
              this.notesPopupVisible = true;
            } else this.commentsPopupVisible = true;
          },
        },

        audit: {
          icon: "clock",
          onClick: () => {
            this.auditPopupVisible = true;
          },
        },
        closeSplit: {
          icon: "close",
          onClick: () => {
            if (this.backRoute)
              this.$router
                .push({
                  path: this.backRoute,
                })
                .then((res) => {
                  if (res)
                    setTimeout(() => {
                      this.$store.dispatch("ui/setViewRouted", true);
                    }, 50);
                });
          },
        },
        save: {
          tabIndex: -1,
          icon: this.toolbarOptions.saveIcon
            ? this.toolbarOptions.saveIcon
            : "floppy",
          // disabled: true,
          validationGroup: "formsData",
          onClick: () => {
            this.focusOutOnEditors();
            // this.itemSaveCallBack(this.dataModel);
            if (this.commentPopUpItems && this.commentPopUpItems.length != 0)
              this.isValid = true;
            else this.itemSaveCallBack(true, []);
          },
        },
        edit: {
          icon: "edit",
          visible:
            this.toolbarOptions.editVisible === false
              ? this.toolbarOptions.editVisible
              : true,
          onClick: () => {
            this.formsConfig.formMode = "edit";
            var editURL = this.backRoute;
            if (this.toolbarOptions.editURL)
              editURL = this.toolbarOptions.editURL;
            if (this.baseView.query) {
              this.$router
                .push({
                  path: editURL + `/edit/${this.baseView.id}`,
                  query: this.baseView.query,
                })
                .then(() => {
                  if (this.toolbarOptions.editCallBack) {
                    this.toolbarOptions.editCallBack();
                  }
                });
            } else {
              this.$router
                .push({
                  path: editURL + `/edit/${this.baseView.id}`,
                })
                .then(() => {
                  if (this.toolbarOptions.editCallBack) {
                    this.toolbarOptions.editCallBack();
                  }
                });
            }
          },
        },
        ellipsis: this.toolbarOptions.ellipsis
          ? {
              tabIndex: -1,
              icon: "more",
              class: "gc-dropdown-icon-button",
              stylingMode: "text",
              showArrowIcon: false,
              disabled:
                this.toolbarOptions.ellipsis.disabled == true ? true : false,
              items:
                this.toolbarOptions.ellipsis &&
                this.toolbarOptions.ellipsis.menuItems
                  ? this.toolbarOptions.ellipsis.menuItems.map((el) => {
                      if (typeof el == "object")
                        return {
                          menuText: el.menuText,
                          visible: el.visible != undefined ? el.visible : true,
                          disabled:
                            el.disabled != undefined ? el.disabled : false,
                        };
                      else return { menuText: el };
                    })
                  : [],
              keyExpr: "menuText",
              displayExpr: "menuText",
              dropDownOptions: { width: 150 },
              onItemClick: (e) => {
                if (this.toolbarOptions.ellipsis.clickAction)
                  this.toolbarOptions.ellipsis.clickAction(e);
              },
            }
          : undefined,

        copy: {
          icon: "copy",
          validationGroup: "formsData",
          onClick: async () => {
            this.toolbarOptions.copyCallBack();
          },
        },
        delete: {
          icon: "trash",
          validationGroup: "formsData",
          onClick: async () => {
            this.toolbarOptions.deleteCallBack();
          },
        },
      },
      formKey: "1",
      isValid: false,
      toolbarFormisValid: false,
      toolbarFormBrokenRules: [],
      previewPdfs: [],
      emailRecords: [],
      orderNotesColumns: [
        {
          caption: "Note",
          dataField: "Note",
          dataType: "string",
          // width: 400,
          alignment: "left",
          // cellTemplate: "note-template",
          allowEditing:
            this.baseView && this.baseView.mode
              ? this.baseView.mode != "review"
              : false,
          showEditorAlways:
            this.baseView && this.baseView.mode
              ? this.baseView.mode != "review"
              : false,
          editorOptions: {
            maxLength: 10,
            validationRules: [
              {
                type: "required",
                message: "Note is required",
              },
            ],
          },
          validationRules: [
            {
              type: "required",
              message: "Note is required",
            },
          ],
        },

        {
          dataField: "ActionDelete",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionDelete",
          visible:
            this.baseView && this.baseView.mode
              ? this.baseView.mode != "review"
              : false,
          cssClass: "class-custom-btn",
          valueChangeCallBack: this.deleteOrderNotes,
        },
      ],
    };
  },
  watch: {
    getHotKeySave(value) {
      if (value) {
        this.$store.dispatch("hotKey/setHotKeySave", false);

        this.focusOutOnEditors();

        if (this.toolbarOptions.saveOptions && this.baseView.mode != "review") {
          this.saveOptionItemClick({
            itemData: this.toolbarOptions.saveOptions.items.find(
              (x) => x.default == true
            ),
          });
        } else {
          if (this.commentPopUpItems) this.isValid = true;
          else this.itemSaveCallBack(true, []);
        }
      }
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    ...mapGetters({ commentPopUpItems: "ui/getCommentPopUpItems" }),
    ...mapGetters({
      reportPdfScreens: "reportPdfPreview/getReportPreviewScreens",
    }),
    auditModel() {
      if (this.toolbarOptions.audit)
        return {
          FormattedDateCreated: `${this.dataModel.CreatedBy} ${
            this.dataModel.DateCreated
              ? this.dataModel.DateCreated.toFriendlyDBDateTimeString()
              : null
          }`,
          FormattedDateChanged: this.dataModel.ChangedBy
            ? `${this.dataModel.ChangedBy} ${
                this.dataModel.DateChanged
                  ? this.dataModel.DateChanged.toFriendlyDBDateTimeString()
                  : null
              }`
            : null,
        };
      else return {};
    },
    saveOptions() {
      return {
        tabIndex: -1,
        icon: this.toolbarOptions.saveIcon
          ? this.toolbarOptions.saveIcon
          : "floppy",
        validationGroup: "formsData",
        items: this.toolbarOptions.saveOptions.items,
        keyExpr: this.toolbarOptions.saveOptions.keyExpr,
        displayExpr: this.toolbarOptions.saveOptions.displayExpr,
        showArrowIcon: false,
        dropDownOptions: this.toolbarOptions.saveOptions.dropDownOptions,
        stylingMode: "text",
        onItemClick: async (e) => {
          this.saveOptionItemClick(e);
        },
      };
    },
    computedStatus() {
      if (this.dataModel) {
        if (this.dataModel.FriendlyStatus) return this.dataModel.FriendlyStatus;
        else if (this.dataModel.Status) return this.dataModel.Status;
        else return "";
      } else return "";
    },
    computedCustomStatus() {
      if (this.dataModel[this.toolbarOptions.customStatus.key])
        return this.dataModel[this.toolbarOptions.customStatus.key];
      else return "";
    },
    orderNotesGridToolbar() {
      return {
        search: true,
        columnChooser: false,
        export: false,
        openFilter: false,
        header: false,
        customButtons: [
          {
            icon: "plus",
            label: "Add Note",
            // route: this.salesOrderCreateRoute,
            clickAction: () => {
              let grid =
                this.$refs["gc-popup-order-notes"].$refs[
                  "gc-dat-gridgc-popup-search-for-item"
                ].instance;
              grid.addRow();
            },
            elementAttr: {
              class: "cx-color-button",
            },
            buttonLocation: "left",
            visible:
              this.baseView && this.baseView.mode
                ? this.baseView.mode != "review"
                : false,
          },
        ],
      };
    },
    getAuditFormItems() {
      if (this.toolbarOptions && this.toolbarOptions.auditItems) {
        return this.toolbarOptions.auditItems;
      } else {
        return [
          {
            itemType: "group",
            caption: "",
            items: [
              {
                dataField: "FormattedDateCreated",
                label: { text: "Created By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  // // disabled: true,
                },
              },
              {
                dataField: "FormattedDateChanged",
                label: { text: "Changed By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  // disabled: true,
                },
              },
            ],
          },
        ];
      }
    },
  },
  methods: {
    deleteOrderNotes(e, lineData, grid) {
      grid.deleteRow(lineData.rowIndex);
    },
    saveOptionItemClick(e) {
      if (this.toolbarOptions.saveOptions.saveKey)
        this.dataModel[this.toolbarOptions.saveOptions.saveKey] =
          e.itemData[this.toolbarOptions.saveOptions.keyExpr];

      if (this.toolbarOptions.toolbarFormItems) {
        this.toolbarFormisValid = true;
      } else if (this.commentPopUpItems && this.commentPopUpItems.length != 0)
        this.isValid = true;
      else this.itemSaveCallBack(true, []);
    },
    popUpBackButtonClick() {
      this.notesPopupVisible = false;
      this.commentsPopupVisible = false;
      this.auditPopupVisible = false;
    },
    customizeItem(item) {
      if (item.itemType == "simple") {
        item.editorOptions = item.editorOptions || {};

        item.editorOptions.disabled = this.validatingForm
          ? false
          : this.baseView && this.baseView.mode
          ? this.baseView.mode == "review"
          : false;
      }
    },
    commentCalueChangeCallBack(isValid, brokenRules) {
      this.isValid = false;
      this.itemSaveCallBack(
        isValid,
        brokenRules.concat(this.toolbarFormBrokenRules)
      );
    },
    toolbarFormCallBack(isValid, brokenRules) {
      this.toolbarFormisValid = false;

      if (brokenRules.length > 0) this.toolbarFormBrokenRules = brokenRules;
      if (this.commentPopUpItems && this.commentPopUpItems.length != 0) {
        this.isValid = true;
      } else {
        this.itemSaveCallBack(isValid, brokenRules);
      }
    },
  },
  created() {
    // emailMenuItems
    if (this.toolbarOptions.screenName && this.toolbarOptions.email == true) {
      if (this.reportPdfScreens) {
        var emailRecords = this.reportPdfScreens.filter(
          (x) =>
            x.ScreenName == this.toolbarOptions.screenName &&
            x.AvailableForEmail == "Y"
        );

        if (emailRecords.length > 0 && this.toolbarOptions.emailMenuItems) {
          if (this.toolbarOptions.emailMenuItems.makeDisabled) {
            emailRecords = this.toolbarOptions.emailMenuItems.makeDisabled(
              this.dataModel,
              emailRecords
            );
          }
        }

        this.emailRecords = emailRecords;
      }
    }

    if (this.toolbarOptions.screenName && this.toolbarOptions.pdf == true) {
      if (this.reportPdfScreens) {
        var previewPdfs = this.reportPdfScreens.filter(
          (x) =>
            x.ScreenName == this.toolbarOptions.screenName &&
            x.AvailableForPDFPreview == "Y"
        );

        if (previewPdfs.length > 0 && this.toolbarOptions.pdfPreviewMenuItems) {
          if (this.toolbarOptions.pdfPreviewMenuItems.makeDisabled) {
            previewPdfs = this.toolbarOptions.pdfPreviewMenuItems.makeDisabled(
              this.dataModel,
              previewPdfs
            );
          }
        }

        this.previewPdfs = previewPdfs;
      }
    }
  },
};
</script>

<style scoped>
.text-header {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: normal;
}

.ml-none {
  margin-left: 0px;
}
</style>
